import { type CustomListModalTypes } from '../../../shared/components';
import {
  type RENDER_FORM_EXPANDED,
  type RENDER_NORMAL,
} from '../../../shared/constants';
import {
  type ChatMessage,
  type ChatMode,
  type WorkflowInfo,
} from '../../../shared/types';

export enum ChatModuleType {
  SLICE_NAME = 'savicopilot/chatModuleSlice',
  EP_SLICE_NAME = 'savicopilot/chatModuleEpSlice',
}

// Render mode
export type RenderModeType = typeof RENDER_NORMAL | typeof RENDER_FORM_EXPANDED;

// Reducer State
export interface ChatModuleState {
  isLoading: boolean;
  renderMode: RenderModeType;
  rightPanel: ChatMessage<ChatMode> | null;
  workflowInfo: WorkflowInfo | null;
  isStreaming: boolean;
  scrollToStep: number | null;
}

export interface BaseProps {
  url: string;
  data: object;
}

export interface PostCustomListProps extends BaseProps {
  queryParams?: object;
}

export interface PostFormDataProps extends BaseProps {
  isECMv6?: boolean;
}

export interface ListViewerApiResponse {
  data?: CustomListModalTypes[];
  totalRecords?: number;
  success: boolean;
  page?: {
    max: number;
    offset: number;
  };
  errorcode?: number;
  error: string;
}

export interface SodListApiResponse {
  totalRecords?: number;
  status: number;
  message: string;
  page?: { max: number; offset: number };
}
